import React, { useEffect } from "react";

const RadarChart = () => {
  useEffect(() => {
    // JavaScript to add radar points dynamically after component mounts

    const radar = document.getElementById("radar");
    const numPoints = 6; // Number of points to be added
    const radius = 130; // Radius from center (in px)

    // Example data to position the points on the radar
    const radarData = [15, 30, 50, 70, 90, 60, 80, 100]; // These could be percentages or scores

    // Create radar points dynamically based on data
    radarData.forEach((dataValue, index) => {
      const angle = (360 / numPoints) * index; // Angle for each point
      const pointRadius = (dataValue / 100) * radius; // Adjusting the point distance based on value

      // Calculate the position using polar to Cartesian conversion
      const x = pointRadius * Math.cos((angle * Math.PI) / 180);
      const y = pointRadius * Math.sin((angle * Math.PI) / 180);

      // Create a new point
      const point = document.createElement("div");
      point.classList.add("radar-point");
      point.style.left = `${radar.offsetWidth / 2 + x - 2.5}px`; // Centering and adjusting for dot size
      point.style.top = `${radar.offsetHeight / 2 - y - 2.5}px`; // Centering and adjusting for dot size

      radar.appendChild(point);
    });
  }, []); // Empty dependency array ensures this effect runs once after the initial render

  return (
    <div style={{ width: "fit-content" }}>
      <div id="radar">
        <div className="beacon" id="beacon"></div>
        <div className="beacon" id="beacon-75"></div>
        <div className="beacon" id="beacon-50"></div>
        <div className="beacon" id="beacon-25"></div>
        <div className="circle" id="circle-biggest"></div>
        <div className="circle" id="circle-big"></div>
        <div className="circle" id="circle-regular"></div>
        <div className="circle" id="circle-medium"></div>
        <div className="circle" id="circle-regular-medium"></div>
        <div className="circle" id="circle-small"></div>
        <div className="circle" id="dot"></div>
        <div id="vertical"></div>
        <div id="horizontal"></div>
      </div>
    </div>
  );
};

export default RadarChart;
